import r from "./PhoneNumberInput.mjs";
import "../../../jsx-runtime-c20f6c15.mjs";
import "react";
import "clsx";
import "react-phone-number-input";
export {
  r as default
};
